// extracted by mini-css-extract-plugin
module.exports = {"showMore":"ShowMore_showMore__2udYv","showMoreBtn":"ShowMore_showMoreBtn__3CXU5"};